'use strict';
import * as $j_java$002elang$002e$002dEnum from "./java.lang.-Enum.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.jZ = ordinal;
  $j_java$002elang$002e$002dEnum.$ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  this.q = null;
  this.M = 0;
  this.jZ = 0;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = new $j_java$002elang$002e$002dEnum.$h_jl_Enum();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.hr = (function(context, buf) {
  return true;
});
$p.gG = (function(context, text, position) {
  var x6 = this.jZ;
  switch (x6) {
    case 0: {
      context.lX = true;
      break;
    }
    case 1: {
      context.lX = false;
      break;
    }
    case 2: {
      context.ej = true;
      break;
    }
    case 3: {
      context.ej = false;
      break;
    }
    default: {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x6);
    }
  }
  return position;
});
$p.b = (function() {
  switch (this.jZ) {
    case 0: {
      return "ParseCaseSensitive(true)";
      break;
    }
    case 1: {
      return "ParseCaseSensitive(false)";
      break;
    }
    case 2: {
      return "ParseStrict(true)";
      break;
    }
    case 3: {
      return "ParseStrict(false)";
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalStateException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalStateException(), "Unreachable");
    }
  }
});
